package com.milta.feature.admin.domain.usecase

import com.milta.feature.admin.domain.entity.AdminPrompt
import com.milta.feature.admin.domain.repository.AdminRepository

class GetAdminPromptsUseCase(private val repository: AdminRepository) {
    suspend operator fun invoke(): Result<List<AdminPrompt>> = repository.getPrompts()
}
